import React from 'react';

import styles from './Button.module.css';

const Button = ({ id, children, disabled, onClick, style, deleteButton, tooltipText, className = null }) => {
    let classNameStr = `${styles.button}`;
    if (deleteButton) {
        classNameStr += ' ' + styles.deleteButton;
    }
    if (className) {
        classNameStr += ' ' + className;
    }

    return (
        <button
            id={id ? id : ''}
            className={classNameStr}
            style={style}
            disabled={disabled}
            onClick={onClick}
            title={tooltipText}>
            {children}
        </button>
    );
};

export default React.memo(Button);
